module.exports = __webpack_public_path__ + "static/service2-c399f3f4ca60385a5af8014d30a9e82b.png";